import React from 'react'
import { useField } from 'formik'
import NumberFormat from 'react-number-format'

function NeoNumber({ value, className, onChange, onKeyPress, disabled, tabIndex, ...props }) {
  const [field] = useField(props)
  return (
    <NumberFormat
      tabIndex={tabIndex}
      allowNegative={false}
      className={className}
      displayType={'input'}
      thousandSeparator={true}
      decimalScale={'2'}
      fixedDecimalScale={true}
      maxLength={15}
      isNumericString
      onValueChange={onChange}
      onKeyPress={(event) => {
        if (/^0/.test(event.target.value)) {
          event.preventDefault();
        }
      }}
      disabled={disabled}
      {...field}
    />
  )
}

export default React.memo(NeoNumber)
